import echarts from 'echarts'
import merge from 'lodash/merge'
let setAdaption = function (size, setPro, data) {
    if (!setPro) {
        // 默认值
        return 10 * size
    }
    return setPro * size;
};

export const pieOption = (setPro, element_id, data) => {
    let chart = echarts.init(document.getElementById(element_id))
    // let innerData = data.inner
    let legendInner = data && data.inner.map(v => v.name) //内环legend
    const myOption = {
        series: [{
            data: data && data.inner
        }]
    }
    let option = {
        color: ['#40A9FF', ' #26C9C3', '#73D13D', ' #FFC53D', '#FFA940', '#F57582', '#9F69E2', ' #6682F5', '#F273B5'],
        title: {
            show: false,
            text: '我是标题',
            left: 14.08,
            top: "3%",
            textStyle: {
                fontFamily: "MicrosoftYaHei",
                fontSize: setAdaption(1.1, setPro),
                color: "rgba(24, 144, 255, 1)",
                fontWeight: 400,
                lineHeight: 30,
            },
        },
        legend: {
            right: '5%',
            top: 'center',
            orient: 'vertical',
            icon: "circle", //图例图形
            data: legendInner,
            textStyle: {
                fontSize: setAdaption(0.6, setPro),
                color: "rgba(255, 255, 255, 0.65)",
                lineHeight: setAdaption(0.85, setPro)
            },
        },
        tooltip: {
            trigger: 'item',
            formatter: (params) => {
                let str = `<span style="display:inline-block;width:12px;height:12px;
                border-radius:50%;background-color:`+params.color+`;margin-right:5px">
                </span>` + params.name + ': ' + params.value + '%'
                return str
            },
            textStyle: {
                color: "rgba(255, 255, 255, 1)"
            }
        },
        series: [{
                name: '',
                type: 'pie',
                radius: [0, '52%'],
                center: ["35%", "45%"],
                itemStyle: {
                    normal: {
                        borderColor: 'rgba(9, 29, 75, 1)',
                        borderWidth: setAdaption(0.05, setPro),
                    }
                },
                label: {
                    normal: {
                        show: false,
                        position: 'inner'
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data: []
            }
        ]
    }

    const finalSeries = merge(option, myOption)

    chart.setOption(finalSeries)

    // 设置toolTip轮播效果
    let index = 0, data_len = option.series[0].data.length;
    chart.timer = null;
    function autoTip() {
        clearInterval(chart.timer)
        chart.timer = setInterval(() => {
            chart.dispatchAction({
                type: 'showTip',
                seriesIndex: 0,
                dataIndex: index
            })
            chart.dispatchAction({
                type: 'downplay',
                seriesIndex: 0,
                dataIndex: index === 0 ? data_len-1 : index-1
            });
            chart.dispatchAction({
                type: 'highlight',
                seriesIndex: 0,
                dataIndex: index
            })
            index++;
            if (index >= data_len) {
                index = 0;
            }
        }, 3000)
    }
    autoTip()

    return chart
}